// src/services/promotionService.ts
export const promotionService = {
  // Get earn points rules
  getEarnPointsRules: async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const apiUrl = process.env.REACT_APP_API_URL;
      const shop_domain = localStorage.getItem('shop_domain');
      const response = await fetch(
        `${apiUrl}${shop_domain}/api/v1/customer/earn-point-rules`,
        {
          headers: {
            Authorization: `Bearer ${token}`, 
          },
        }
      );
      const result = await response.json();
      return result.data;
    } catch (error) {
      throw error;
    }
  },

  // Redeem points
  calculatePointsRule: async (type: string) => {
    try {
      const token = localStorage.getItem('accessToken');
      const apiUrl = process.env.REACT_APP_API_URL;
      const shop_domain = localStorage.getItem('shop_domain');
      const response = await fetch(
        `${apiUrl}${shop_domain}/api/v1/customer/earn-point-rules`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ type }),
        }
      );
      const result = await response.json();
      return result.data;
    } catch (error) {
      throw error;
    }
  }
};